var React = require('react');

function LiquorIcon (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M332.74 315.35c30.88-33.43 50.15-78.2 50.15-127.5C382.9 84.43 298.72 0 195.02 0S7.2 84.43 7.2 187.85 91.33 375.7 195.03 375.7c42.22 0 81.03-13.88 112.48-37.4l139.7 139.68c3.4 3.4 7.65 5.1 11.9 5.1s8.78-1.7 11.9-5.1c6.5-6.5 6.5-17.28 0-24.08L332.74 315.35zM41.2 187.85C41.2 103.13 110.03 34 195.03 34c84.72 0 153.85 68.85 153.85 153.85S280.03 341.7 195.03 341.7 41.2 272.57 41.2 187.85z"}));
}

LiquorIcon.displayName = "LiquorIcon";

LiquorIcon.defaultProps = {"viewBox":"0 0 483.083 483.083"};

module.exports = LiquorIcon;

LiquorIcon.default = LiquorIcon;
